module.exports = __webpack_public_path__ + "static/media/galerija_2019 (18).303f4011.jpg";